import { useFilterPaymentMethodContext } from "./filter-payment-method.context";

export function FilterPaymentMethod() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterPaymentMethodContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}